export const CREATE_CAP = {
  Company: ["CNF", "Super Stockist", "Distributor", "Micro Distributor", "Retailer"],
  CNF: ["Super Stockist"],
  "Super Stockist": ["Distributor"],
  Distributor: ["Micro Distributor", "Retailer"],
  "FOS": ["Retailer"],
};